import React from 'react';

var CloseIcon = function CloseIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17.24",
    height: "17.24",
    viewBox: "0 0 17.24 17.24",
    alt: "x"
  }, props), React.createElement("g", {
    id: "Gruppe_440",
    "data-name": "Gruppe 440",
    transform: "translate(2.12 2.12)"
  }, React.createElement("line", {
    id: "Linie_23",
    "data-name": "Linie 23",
    x2: "12.093",
    y2: "13",
    transform: "translate(0.453)",
    fill: "none",
    stroke: props.color ? props.color : '#a1a0ae',
    strokeLinecap: "round",
    strokeWidth: "3"
  }), React.createElement("line", {
    id: "Linie_24",
    "data-name": "Linie 24",
    x2: "12.093",
    y2: "13",
    transform: "translate(13 0.454) rotate(90)",
    fill: "none",
    stroke: props.color ? props.color : '#a1a0ae',
    strokeLinecap: "round",
    strokeWidth: "3"
  })));
};

export default CloseIcon;